<template>
  <MedicalRequestList
    v-if="!lodash.isEmpty(medicalRequestsQueue)"
    :attendance="attendance"
    :exams="medicalRequestsQueue"
    :refreshQueueProps="refreshQueue"
  />
</template>

<script>
  import GET_EXAM_REQUESTS from "@/graphql/medical_request/medical_requests_queue.js";

  import MedicalRequestList from "@/components/medical_request/list/index.vue";

  export default {
    name: "MedicalRequestQueue",
    props: {
      queueType: String,
      attendance: Object,
      employeeId: {
        type: String,
        default: "",
      },
    },
    components: {
      MedicalRequestList,
    },
    data() {
      return {
        medicalRequestsQueue: [],
      };
    },
    apollo: {
      medicalRequestsQueue: {
        query: GET_EXAM_REQUESTS,
        deep: true,
        variables() {
          return {
            queueType: this.queueType,
            attendanceId: this.attendance.id,
            employeeId: this.employeeId,
          };
        },
        pollInterval: 20000,
      },
    },
    updated() {
      this.refreshQueue();
    },
    methods: {
      refreshQueue() {
        this.$apollo.queries.medicalRequestsQueue.refetch();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
